import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoginService } from './services/login.service';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

export const addJwtInterceptor: HttpInterceptorFn = (req, next) => {
  // Do not add jwt auth token to auth header for api/login call.
  if (req.url.indexOf('api/login') > -1) {
    return next(req);
  }

  const loginService = inject(LoginService);
  const accessToken = loginService.accessToken;

  if (accessToken) {
    req = req.clone({
      setHeaders: {
        Authentication: `Bearer ${accessToken}`
      }
    });
  } else {
    var jwtFromLocalStorage = localStorage.getItem("jwt");
    // TODO: Check if jwt is expired.
    if (jwtFromLocalStorage) {
      req = req.clone({
        setHeaders: {
          Authentication: `Bearer ${jwtFromLocalStorage}`
        }
      });
    }
  }

  // TODO: Block server call if no auth token?

  // Intercept responses so we can handle 401 globally
  const router = inject(Router);
  return next(req).pipe(
    catchError((err) => {
      // Only handle HttpErrorResponse and 401 Unauthorized
      if (err instanceof HttpErrorResponse && err.status === 401) {
        // log out and navigate to home so the app can re-authenticate
        loginService.logout();
        try {
          router.navigate(['/']);
        } catch (e) {
          // ignore navigation failures
        }
      }
      return throwError(() => err);
    })
  );
};
